import { cn } from '@/lib/utils';
import {
  SubmitterUser,
  displaySubmitterName,
} from '@/utils/displaySubmitterName';
import { isUnnamedSubmitter } from '@/components/bans/bannedPersonAvatar';
import { GuestAvatar } from '@/components/bans/GuestAvatar';

export function SubmitterName({
  user,
  userId,
  className,
  truncate = false,
}: {
  user?: SubmitterUser;
  userId?: string | null;
  className?: string;
  truncate?: boolean;
}) {
  const { text, title } = displaySubmitterName(user, userId, {
    truncate,
  });
  const guest = isUnnamedSubmitter(user);
  const [guestLabel, guestSuffix] = guest ? text.split(' · ') : [];

  return (
    <span
      className={cn('inline-flex min-w-0 max-w-full items-center gap-1.5')}
      title={title ?? text}
    >
      {guest ? <GuestAvatar /> : null}
      <span
        className={cn(
          'min-w-0 truncate',
          guest
            ? 'font-normal text-muted-foreground'
            : 'font-medium text-foreground',
          className,
        )}
      >
        {guest ? (
          <>
            {guestLabel}
            {guestSuffix ? (
              <>
                {' · '}
                <span className="font-mono">{guestSuffix}</span>
              </>
            ) : null}
          </>
        ) : (
          text
        )}
      </span>
    </span>
  );
}

export function GuestFallbackHint() {
  return (
    <p className="text-xs text-muted-foreground">
      No nickname set, so it shows the last 4 characters of the ID.
    </p>
  );
}
